/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
/* eslint-disable no-debugger */
import { CommonModule } from '@angular/common';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { Step3Form } from '@/app/interfaces/step3-form';
import normative from '@/app/enums/normative.enum';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TextareaModule } from 'primeng/textarea';
import { DatePickerModule } from 'primeng/datepicker';
import { InputMaskModule } from 'primeng/inputmask';
import { DesyAngularModule } from 'desy-angular';
import { TooltipComponent } from '@/app/shared/tooltip/tooltip.component';

@Component({
  selector: 'app-step3',
  standalone: true,
  imports: [
    SelectModule,
    InputTextModule,
    FloatLabelModule,
    SelectButtonModule,
    ButtonsComponent,
    DatePickerModule,
    ReactiveFormsModule,
    TextareaModule,
    CommonModule,
    InputMaskModule,
    DesyAngularModule,
    FormsModule,
    TooltipComponent,
  ],
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class Step3Component implements OnChanges {
  form: FormGroup;

  // opciones para el select (lo mantenemos como signal)
  normativeOptions = Object.values(normative).map((el, i) => {
    if (i === 0) {
      return { text: 'Selecciona una opción...', value: '' };
    } else {
      return { text: el.ES, value: el.EN };
    }
  });

  @Input() formData: Partial<Step3Form> | null = null;
  @Output() step3Completed = new EventEmitter<Step3Form>();
  @Output() formIsValid = new EventEmitter<boolean>();
  @Output() formDataChange = new EventEmitter<Partial<Step3Form>>();

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      type: ['', Validators.required],
      range: ['', Validators.required],
      date: [null, Validators.required],
      title: ['', Validators.required],
      url: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(https?:\/\/)?([\w\-])+(\.[\w\-]+)+[\/#?]?.*$/),
          Validators.pattern(/^[^#]*$/),
        ],
      ],
      infinityDate: [true],
      effectiveDate: [new Date(2099, 11, 31)],
    });

    this.form.get('infinityDate')?.valueChanges.subscribe((value) => {
      this.toggleEffectiveDateValidators(value);
    });
    this.toggleEffectiveDateValidators(this.form.get('infinityDate')?.value);

    this.form.statusChanges.subscribe(() => {
      this.formIsValid.emit(this.form.valid);
    });

    this.form.valueChanges.subscribe((value) => {
      this.formDataChange.emit(value);
    });
    console.log(this.form.contains('title'), this.form.get('title'));
  }

  get stateOptions() {
    return [
      { label: 'Indefinida', value: true },
      { label: 'Seleccionar fecha', value: false },
    ];
  }

  private toggleEffectiveDateValidators(infinity: boolean) {
    const eff = this.form.get('effectiveDate');
    if (!eff) return;

    if (infinity) {
      eff.clearValidators();
      eff.setValue(new Date(2099, 11, 31));
      eff.updateValueAndValidity();
    } else {
      eff.setValidators([Validators.required]);
      // si tenía la fecha "lejana", la ponemos a null para forzar selección
      if (eff.value && eff.value.getFullYear && eff.value.getFullYear() === 2099) {
        eff.setValue(null);
      }
      eff.updateValueAndValidity();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['formData']?.currentValue) return;

    const incoming = changes['formData'].currentValue as Partial<Step3Form>;

    const toPatch: Partial<Step3Form> = {};

    const eq = (a, b) => (a instanceof Date && b instanceof Date ? a.getTime() === b.getTime() : a === b);

    for (const key of Object.keys(this.form.controls)) {
      if (incoming[key as keyof Step3Form] !== undefined) {
        const next = incoming[key as keyof Step3Form];
        const cur = this.form.get(key)?.value;
        if (!eq(cur, next)) toPatch[key] = next;
      }
    }

    if (Object.keys(toPatch).length) {
      this.form.patchValue(toPatch, { emitEvent: false });
    }
  }

  onSubmit() {
    if (this.form.invalid) {
      this.markInputs(this.form);
      this.scrollToFirstInvalid();
      this.formIsValid.emit(false);
      return;
    }
    this.formIsValid.emit(true);
    this.emitStep3Data();
    console.log('Formulario válido', this.form.value);
  }

  markInputs(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((c) => {
      const control = formGroup.get(c);
      if (control instanceof FormGroup) {
        this.markInputs(control);
      } else {
        control?.markAsTouched({ onlySelf: true });
        control?.markAsDirty({ onlySelf: true });
      }
    });
  }

  private scrollToFirstInvalid() {
    const firstInvalid = document.querySelector('.ng-invalid');
    if (firstInvalid) {
      (firstInvalid as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
      (firstInvalid as HTMLElement).focus?.();
    }
  }

  emitStep3Data() {
    const v = this.form.value;
    this.step3Completed.emit({
      type: v.type,
      range: v.range,
      date: v.date,
      title: v.title,
      url: v.url,
      effectiveDate: v.effectiveDate,
    });
  }
}
